import { useEffect, useState } from 'react';
import { isVisibleRangeInFetchWindow } from '../helpers/complianceCalendarHelpers';

type UseHasOutrunFetchBufferParams = {
  endDateString: string;
  isLoading: boolean;
  isPreviousData: boolean;
  startDateString: string;
  visibleRangeExclusiveEnd: Date;
  visibleRangeStart: Date;
};

export function useHasOutrunFetchBuffer({
  endDateString,
  isLoading,
  isPreviousData,
  startDateString,
  visibleRangeExclusiveEnd,
  visibleRangeStart,
}: UseHasOutrunFetchBufferParams): boolean {
  // Last successfully fetched ±1 buffer. Adjacent next/prev pages are already
  // inside it; skeletons only when navigation outruns that buffer.
  const [loadedFetchWindow, setLoadedFetchWindow] = useState<{
    start: string;
    end: string;
  } | null>(null);

  useEffect(() => {
    if (!isLoading && !isPreviousData && startDateString && endDateString) {
      setLoadedFetchWindow({ start: startDateString, end: endDateString });
    }
    return undefined;
  }, [isLoading, isPreviousData, startDateString, endDateString]);

  return (
    isPreviousData &&
    !(
      loadedFetchWindow &&
      isVisibleRangeInFetchWindow({
        visibleStart: visibleRangeStart,
        visibleExclusiveEnd: visibleRangeExclusiveEnd,
        fetchWindowStart: loadedFetchWindow.start,
        fetchWindowEnd: loadedFetchWindow.end,
      })
    )
  );
}
